import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDataWithStudent } from "../../../lib/awardlist";
import { getNotesData, addData, updateData } from "../../../lib/pagenotes";
import { deleteIdData } from "../../../lib/awardlist";
//import {useAuth} from "../../../usercontext";

export default function GlobalStudentAwardsList({
  slug,
  isStudent,
  show = true,
  studentRole,
}) {
  const [awardlist, setAwardList] = useState([]);
  const [description, setDescription] = useState();
  const [recId, setRecId] = useState();
  const [status, setStatus] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortField, setSortField] = useState(null);

  const pageName = "StudentAwardList";

  const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			await deleteIdData(id)
			getDatafromAwardList()
		}
	}

	async function getDatafromAwardList() {
		const award = await getDataWithStudent(slug)
		setAwardList(award)
	}
	const handleSort = (field) => {
		const sortedList = [...awardlist].sort((a, b) => {
			if (field === 'description') {
				return sortOrder === 'asc' ? a.description.localeCompare(b.description) : b.description.localeCompare(a.description)
			} else if (field === 'sortorder') {
				return sortOrder === 'asc' ? a.sortorder - b.sortorder : b.sortorder - a.sortorder
			} else if (field === 'recoglevel') {
				return sortOrder === 'asc' ? a.recoglevel.localeCompare(b.recoglevel) : b.recoglevel.localeCompare(a.recoglevel)
			} else if (field === 'gradelevel') {
				return sortOrder === 'asc' ? a.gradelevel - b.gradelevel : b.gradelevel - a.gradelevel
			} else if (field === 'ranking') {
				return sortOrder === 'asc' ? a.ranking.localeCompare(b.ranking) : b.ranking.localeCompare(a.ranking)
			}
			return 0
		})

		setAwardList(sortedList)
		setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
		setSortField(field)
	}

	async function RecordCheck() {
		const sdata = await getNotesData(slug, '', pageName)
		//console.log("RecordCheck", sdata);

		if (sdata.length === 0) {
			setStatus('Add')
		} else {
			setStatus('Update')
			setRecId(sdata[0].id)
			GetNotes()
		}
	}

	async function GetNotes() {
		const sdata = await getNotesData(slug, '', pageName)
		setDescription(sdata[0].instructorNote)
		setRecId(sdata[0].id)
	}

	const handleSubmitforGoals = async (e) => {
		e.preventDefault()
		if (status == 'Add') {
			await addData({
				page: pageName,
				studentId: slug,
				instructorNote: description
			})
			setStatus('Update')
		} else {
			await updateData({
				id: recId,
				page: pageName,
				studentId: slug,
				instructorNote: description
			})
		}
		setShowMessage(true)
	}

	const messages = () => {
		return (
			<div className="alert alert-success alert-dismissible fade show" role="alert">
				<strong>Data Updated...</strong> {/*You should check in on some of those fields below.*/}
				<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={(e) => setShowMessage(false)}></button>
			</div>
		)
	}

	useEffect(() => {
		RecordCheck()
		getDatafromAwardList()
	}, [])

	const essentialheader = (
		name,
		student911buttonname,
		student911buttonlink,
		student12buttonname,
		student12buttonlink,
		instructorbuttonname,
		instructorbuttonlink
	) => {
		return (
			<div className="d-flex p-1 pb-0 justify-content-between align-items-center">
				<div>
					<h4>{name}</h4>
					<p></p>
				</div>
				<div className="d-flex">
					<div className="ticket-btn-grp">
						{show ? (
							isStudent ? (
								studentRole === 'Student911' ? (
									<Link to={student911buttonlink}>{student911buttonname}</Link>
								) : (
									<Link to={student12buttonlink}>{student12buttonname}</Link>
								)
							) : (
								<Link to={instructorbuttonlink}>{instructorbuttonname}</Link>
							)
						) : (
							''
						)}
					</div>
				</div>
			</div>
		)
	}
	return (
		<div className="col-12 p-1">
			<div className="settings-inner-blk p-0">
				<div className="comman-space p-2 card wish-card">
					{/* <div className="p-3">
          <div className="new-address">
            <div className="row">
              <div className="col"><h3 className="goal_settings_title">Student Award List</h3></div>
              <div className="col"> </div>
              <div className="col">
                {show ? (
                  isStudent ? (
                    studentRole === "Student911" ? (
                      <Link
                        to="/student911/student-awards-edit/Add/0"
                        className="btn btn-dark btn-dark-1"
                      >
                        Add New Award
                      </Link>
                    ) : (
                      <Link
                        to="/student12/student-awards-edit/Add/0"
                        className="btn btn-dark btn-dark-1"
                      >
                        Add New Award
                      </Link>
                    )
                  ) : (
                    <Link
                      to={`/instructor/instructor-studentawards-edit/${slug}/Add/0`}
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Award
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div> */}
					{essentialheader(
						'Student Award List',
						'Add New Award',
						'/student911/student-awards-edit/Add/0',
						'Add New Award',
						'/student12/student-awards-edit/Add/0',
						'Add New Award',
						`/instructor/instructor-studentawards-edit/${slug}/Add/0`
					)}

					<div className="settings-invoice-blk table-responsive">
						<div className="px-2">
							<table className="table table-hover">
								<thead>
									<tr>
										<th>
											#
											<button className="btn btn-link" onClick={() => handleSort('sortorder')}>
												{sortField === 'sortorder' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
											</button>
										</th>
										<th>
											Recog. Level
											<button className="btn btn-link" onClick={() => handleSort('recoglevel')}>
												{sortField === 'recoglevel' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
											</button>
										</th>
										<th>
											Ranking
											<button className="btn btn-link" onClick={() => handleSort('ranking')}>
												{sortField === 'ranking' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
											</button>
										</th>
										<th>
											Grade Level
											<button className="btn btn-link" onClick={() => handleSort('gradelevel')}>
												{sortField === 'gradelevel' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
											</button>
										</th>
										<th>
											Award
											<button className="btn btn-link" onClick={() => handleSort('description')}>
												{sortField === 'description' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
											</button>
										</th>
										{show && <th>Actions</th>}
									</tr>
								</thead>
								{awardlist.map(function (data) {
									return (
										<tbody key={data.id}>
											<>
												<tr key={`order-${data.id}`} className="border-bottom">
													<td>{data.sortorder}</td>
													<td>{data.recoglevel}</td>
													<td>{data.ranking}</td>
													<td>{data.gradelevel}</td>
													<td>{data.description}</td>
													{show && (
														<td>
															<div>
																{isStudent ? (
																	studentRole === 'Student911' ? (
																		<Link to={`/student911/student-awards-edit/Update/${data.id}`} className="btn btn-success btn-sm">
																			Update
																		</Link>
																	) : (
																		<Link to={`/student12/student-awards-edit/Update/${data.id}`} className="btn btn-success btn-sm">
																			Update
																		</Link>
																	)
																) : (
																	<Link to={`/instructor/instructor-studentawards-edit/${slug}/Update/${data.id}`} className="btn btn-success btn-sm">
																		Update
																	</Link>
																)}
																<button className="btn btn-danger btn-sm mx-1" onClick={() => handleDelete(data.id)}>
																	Delete
																</button>
															</div>
														</td>
													)}
												</tr>
											</>
										</tbody>
									)
								})}
							</table>
						</div>
					</div>
					<div className="settings-invoice-blk table-responsive mt-5">
						{showMessage ? messages() : ''}
						<form role="form" onSubmit={handleSubmitforGoals}>
							<div className="row mx-auto">
								<div className="col-12">
									<div className="form-group">
										<label className="form-control-label">Goals and Recommendation</label>
										<textarea
											rows="4"
											value={description}
											onChange={(e) => setDescription(e.target.value)}
											className="form-control"
											placeholder="Description"
										></textarea>
									</div>
								</div>
								{show && (
									<>
										{!isStudent && (
											<div className="update-profile d-flex justify-content-between">
												<button type="submit" className="btn btn-primary">
													Goals and Recommendation Update
												</button>
											</div>
										)}
									</>
								)}
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
